"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.BcInputDateRangeBehavior = void 0;
var bc_calendar_behavior_1 = require("./bc-calendar-behavior");
var bc_date_constants_1 = require("./bc-date-constants");
var common_constants_1 = require("../../../common/constants/common-constants");
var helpers_1 = require("../../../common/helpers");
var bc_abstract_dropdown_constants_1 = require("../../molecules/bc-dropdown/bc-abstract-dropdown-constants");
var bc_abstract_dropdown_behavior_1 = require("../../molecules/bc-dropdown/bc-abstract-dropdown-behavior");
var bc_input_date_behavior_1 = require("./bc-input-date-behavior");
var bc_input_constants_1 = require("../../molecules/bc-input/bc-input-constants");
var bc_date_constants_2 = require("./bc-date-constants");
var bc_date_constants_3 = require("./bc-date-constants");
var bc_date_constants_4 = require("./bc-date-constants");
var bc_date_constants_5 = require("./bc-date-constants");
var bc_date_constants_6 = require("./bc-date-constants");
var bc_date_constants_7 = require("./bc-date-constants");
var bc_date_constants_8 = require("./bc-date-constants");
var bc_calendar_behavior_utilities_1 = require("./bc-calendar-behavior-utilities");
var BcInputDateRangeBehavior = (function (_super) {
    __extends(BcInputDateRangeBehavior, _super);
    function BcInputDateRangeBehavior() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.bcInputDateUtilities = new bc_calendar_behavior_utilities_1.BcCalendarUtilities();
        return _this;
    }
    BcInputDateRangeBehavior.setUpAll = function () {
        var inputDateElements = Array.from(document.querySelectorAll(".".concat(bc_date_constants_1.BcDateConstants.RANGE_MOLECULE_CLASSES)));
        var elements = [];
        for (var _i = 0, inputDateElements_1 = inputDateElements; _i < inputDateElements_1.length; _i++) {
            var element = inputDateElements_1[_i];
            var inputDateElement = new BcInputDateRangeBehavior();
            inputDateElement.setElement(element);
            inputDateElement.setUp();
            elements.push(inputDateElement);
        }
        return elements;
    };
    BcInputDateRangeBehavior.prototype._setUp = function () {
        this.dropDownId = (0, helpers_1.getId)(BcInputDateRangeBehavior);
        this.inputDate = this.mySelf.querySelectorAll('input')[0];
        this.wrapperCalendar = document.createElement('div');
        this.wrapperCalendar.setAttribute('id', this.dropDownId);
        this.wrapperCalendar.classList.add(bc_abstract_dropdown_constants_1._DROPDOWN_CONTENT_CLASS);
        this.inputDateTwo = this.mySelf.querySelectorAll('input')[1];
        if (this.inputDate.type == 'date') {
            this.inputDate.style.cursor = common_constants_1.BcCommonConstants.CURSOR_POINTER;
        }
        if (this.inputDateTwo.type == 'date') {
            this.inputDateTwo.style.cursor = common_constants_1.BcCommonConstants.CURSOR_POINTER;
        }
        var fastButtons = this.mySelf.getAttribute(bc_date_constants_1.BcDateConstants.FAST_BUTTONS);
        var operations = this.mySelf.getAttribute('operations');
        var rangesText = this.mySelf.getAttribute(bc_date_constants_1.BcDateConstants.RANGES_TEXT);
        var length = this.inputDate.parentElement.getElementsByTagName(common_constants_1.BcCommonConstants.EM_TAG).length;
        var icon = this.inputDate.parentElement.getElementsByTagName(common_constants_1.BcCommonConstants.EM_TAG)[length - 1];
        var lengthTwo = this.inputDateTwo.parentElement.getElementsByTagName(common_constants_1.BcCommonConstants.EM_TAG).length;
        var iconTwo = this.inputDateTwo.parentElement.getElementsByTagName(common_constants_1.BcCommonConstants.EM_TAG)[lengthTwo - 1];
        this.errorTextInput = this.mySelf.getAttribute(bc_date_constants_3.ERROR_TEXT);
        this.successTextInput = this.mySelf.getAttribute(bc_date_constants_5.SUCCESS_TEXT);
        this.errorTextInputTwo = this.mySelf.getAttribute(bc_date_constants_4.ERROR_TEXT_TWO);
        this.successTextInputTwo = this.mySelf.getAttribute(bc_date_constants_6.SUCCESS_TEXT_TWO);
        this.validateInputs = this.mySelf.getAttribute('validateInputs') == 'true' ? true : false;
        this.disabledScroll = this.mySelf.getAttribute('disabledScroll') == 'true' ? true : false;
        this.originalIcon = icon.innerHTML;
        this.originalIconTwo = iconTwo.innerHTML;
        if (this.inputDate.parentElement.querySelector(common_constants_1.BcCommonConstants.SPAN_TAG)) {
            this.helpTextInput = this.inputDate.parentElement.querySelector(common_constants_1.BcCommonConstants.SPAN_TAG).innerHTML;
        }
        else {
            this.helpTextInput = '';
        }
        if (this.inputDateTwo.parentElement.querySelector(common_constants_1.BcCommonConstants.SPAN_TAG)) {
            this.helpTextInputTwo = this.inputDateTwo.parentElement.querySelector(common_constants_1.BcCommonConstants.SPAN_TAG).innerHTML;
        }
        else {
            this.helpTextInputTwo = '';
        }
        this.language = this.mySelf.getAttribute('language') == null ? 'es' : this.mySelf.getAttribute('language');
        var calendar = document.createElement('div');
        var enableBtnConfirmWithOnedate = this.mySelf.getAttribute(bc_date_constants_1.BcDateConstants.BTN_CONFIRM_NO_VALIDATE) == 'true' ? true : false;
        var restoreCalendarWithSetUp = this.mySelf.getAttribute(bc_date_constants_1.BcDateConstants.RESTORE_WITH_SETUP) == 'true' ? true : false;
        calendar.setAttribute('type', 'range');
        calendar.setAttribute(bc_date_constants_1.BcDateConstants.RANGES, fastButtons);
        calendar.setAttribute('operations', operations);
        calendar.setAttribute(bc_date_constants_1.BcDateConstants.RANGES_TEXT, rangesText);
        calendar.setAttribute('language', this.language);
        calendar.setAttribute('disabledDates', this.mySelf.getAttribute('disabledDates'));
        calendar.setAttribute('minDaysRange', this.mySelf.getAttribute('minDaysRange'));
        calendar.setAttribute('maxDaysRange', this.mySelf.getAttribute('maxDaysRange'));
        calendar.classList.add(bc_date_constants_1.BcDateConstants.CALENDAR_CLASS);
        calendar.setAttribute(bc_date_constants_1.BcDateConstants.CALENDAR_HOLIDAY, this.mySelf.getAttribute(bc_date_constants_1.BcDateConstants.CALENDAR_HOLIDAY));
        calendar.setAttribute(bc_date_constants_1.BcDateConstants.BTN_CONFIRM_NO_VALIDATE, String(enableBtnConfirmWithOnedate));
        calendar.setAttribute(bc_date_constants_1.BcDateConstants.RESTORE_WITH_SETUP, String(restoreCalendarWithSetUp));
        this.wrapperCalendar.appendChild(calendar);
        this.calendarElement = calendar;
        this.mySelf.appendChild(this.wrapperCalendar);
        var calendarBehavior = new bc_calendar_behavior_1.BcCalendarBehavior();
        var inputDateBehavior = new bc_input_date_behavior_1.BcInputDateBehavior();
        this.setupMinAndMaxDate();
        calendarBehavior.setElement(this.calendarElement);
        calendarBehavior.setUp();
        inputDateBehavior.setUp();
        this.calendarBehavior = calendarBehavior;
        this.inputDateBaehavior = inputDateBehavior;
        this.configDropDown();
        this.addListeners();
    };
    BcInputDateRangeBehavior.prototype.configDropDown = function () {
        var toogle = document.createElement('div');
        toogle.setAttribute('aria-controls', this.dropDownId);
        toogle.classList.add(bc_abstract_dropdown_constants_1._DROPDOWN_TOGGLE_CLASS);
        toogle.style.display = common_constants_1.BcCommonConstants.NONE;
        this.mySelf.appendChild(toogle);
        this.mySelf.classList.add(bc_abstract_dropdown_constants_1._DROPDOWN_CLASS);
        var dropDowConfig = {
            toggleEvents: ['click', 'focus'],
            extraToggles: [
                {
                    node: this.inputDate,
                    events: ['focus']
                },
                {
                    node: this.inputDateTwo,
                    events: ['focus']
                }
            ],
            static: true,
            isPopUp: false,
            isDisabled: false,
            parentWidth: true,
            contentAutoWidth: true,
            maxHeightContent: this.maxHeightContent
        };
        this.setDropdownContentPosition();
        this.setConfig(dropDowConfig);
        _super.prototype._setUp.call(this);
    };
    BcInputDateRangeBehavior.prototype.addListeners = function () {
        var _this = this;
        this.calendarElement.addEventListener(common_constants_1.BcCommonConstants.EVENT_RANGE, function (e) {
            _this.setInputDateValues(e);
            _this.stylesInputReset();
        });
        this.calendarElement.addEventListener(bc_date_constants_1.BcDateConstants.CALENDAR_EVENT_SELECTED_DATE, function (e) {
            var element = e.detail;
            _this.inputDate.value = _this.inputDateTwo.value;
            _this.inputDateTwo.value = '';
            _this.calendarBehavior.selectedDates = undefined;
            _this.calendarBehavior.firstDateIsSelected = true;
            _this.calendarBehavior.date = undefined;
            _this.calendarBehavior.configFullView(element);
        });
        this.calendarElement.addEventListener(bc_date_constants_1.BcDateConstants.CALENDAR_EVENT_CHANGE_DATE, function (e) {
            _this.setValueInput(e.detail.value, e.detail.numberInput);
        });
        this.calendarElement.addEventListener(common_constants_1.BcCommonConstants.EVENT_CANCEL, function (e) {
            _this.closeDropdown();
            _this.stylesInputReset();
        });
        this.inputDate.addEventListener(common_constants_1.BcCommonConstants.EVENT_CLICK, function (e) {
            _this.calendarBehavior.rangeInputCliked = common_constants_1.COMMON_CONSTANTS_NUMBERS.N1;
            _this.calendarBehavior.eventRangeRestorewithOutSetUp();
            _this.inputDate.value = '';
            _this.inputDateTwo.value = '';
            _this.emitEvent();
            _this.handleClick(e);
            _this._closeCalendarOutside();
        });
        this.inputDate.addEventListener(common_constants_1.BcCommonConstants.EVENT_KEY_PRESS, function (e) {
            if (e.key === common_constants_1.BcCommonConstants.KEY_EVENT_ENTER) {
                e.preventDefault();
                var dropdownActive = _this.validateDropdownIsActive();
                if (!dropdownActive) {
                    _this.openDrowndown();
                    _this.validateMobileDropdown();
                }
            }
        });
        this.inputDate.addEventListener(common_constants_1.BcCommonConstants.EVENT_KEY_DOWN, function (event) {
            if (event.code === common_constants_1.BcCommonConstants.KEY_EVENT_SPACE) {
                event.preventDefault();
                var dropdownActive = _this.validateDropdownIsActive();
                if (!dropdownActive) {
                    _this.openDrowndown();
                    _this.validateMobileDropdown();
                }
            }
        });
        this.inputDateTwo.addEventListener(common_constants_1.BcCommonConstants.EVENT_KEY_PRESS, function (e) {
            if (e.key === common_constants_1.BcCommonConstants.KEY_EVENT_ENTER) {
                e.preventDefault();
                var dropdownActive = _this.validateDropdownIsActive();
                if (!dropdownActive) {
                    _this.openDrowndown();
                    _this.validateMobileDropdown();
                }
            }
        });
        this.inputDateTwo.addEventListener(common_constants_1.BcCommonConstants.EVENT_KEY_DOWN, function (event) {
            if (event.code === common_constants_1.BcCommonConstants.KEY_EVENT_SPACE) {
                event.preventDefault();
                var dropdownActive = _this.validateDropdownIsActive();
                if (!dropdownActive) {
                    _this.openDrowndown();
                    _this.validateMobileDropdown();
                }
            }
        });
        this.inputDateTwo.addEventListener(common_constants_1.BcCommonConstants.EVENT_CLICK, function (e) {
            _this.calendarBehavior.rangeInputCliked = common_constants_1.COMMON_CONSTANTS_NUMBERS.N2;
            _this.handleClick(e);
            _this._closeCalendarOutside();
        });
        this.inputDate.addEventListener(common_constants_1.BcCommonConstants.EVENT_FOCUSOUT, function (e) {
            _this.inputDate.classList.remove(bc_date_constants_2.ACTIVE_CLASS_INPUT);
            _this.validateFocusoutValue(e, _this.inputDate, 1);
            e.preventDefault();
        });
        this.inputDateTwo.addEventListener(common_constants_1.BcCommonConstants.EVENT_FOCUSOUT, function (e) {
            _this.inputDateTwo.classList.remove(bc_date_constants_2.ACTIVE_CLASS_INPUT);
            _this.validateFocusoutValue(e, _this.inputDateTwo, bc_date_constants_1.BcDateConstants.NUMBERS.CALENDAR_N2);
            e.preventDefault();
        });
        var length = this.inputDate.parentElement.getElementsByTagName(common_constants_1.BcCommonConstants.EM_TAG).length;
        var icon = this.inputDate.parentElement.getElementsByTagName(common_constants_1.BcCommonConstants.EM_TAG)[length - 1];
        var lengthTwo = this.inputDateTwo.parentElement.getElementsByTagName(common_constants_1.BcCommonConstants.EM_TAG).length;
        var iconTwo = this.inputDateTwo.parentElement.getElementsByTagName(common_constants_1.BcCommonConstants.EM_TAG)[lengthTwo - 1];
        icon.addEventListener(common_constants_1.BcCommonConstants.EVENT_CLICK, function (e) {
            if (icon.innerHTML == bc_input_constants_1.BC_INPUT_REMOVE_ICON) {
                _this.setDefaultStatusInputClass();
                _this.inputDate.value = '';
                _this.inputDate.focus();
            }
        });
        iconTwo.addEventListener(common_constants_1.BcCommonConstants.EVENT_CLICK, function (e) {
            if (iconTwo.innerHTML == bc_input_constants_1.BC_INPUT_REMOVE_ICON) {
                _this.setDefaultStatusInputTwoClass();
                _this.inputDateTwo.value = '';
                _this.inputDateTwo.focus();
            }
        });
        this.mySelf.querySelectorAll('em').forEach(function (em) {
            if (!em.classList.contains(bc_date_constants_1.BcDateConstants.CANCEL_CLASS)) {
                em.addEventListener(common_constants_1.BcCommonConstants.EVENT_CLICK, function () {
                    _this.openDrowndown();
                    _this._closeCalendarOutside();
                    _this.validateMobileDropdown();
                }, false);
                em.style.cursor = common_constants_1.BcCommonConstants.CURSOR_POINTER;
            }
        });
    };
    BcInputDateRangeBehavior.prototype.validateFocusoutValue = function (e, input, num) {
        if (input.value !== '') {
            if (input.type == 'text') {
                this.validateDates(input, e.target.value);
                this.change(e.target.value, num);
            }
            else {
                var min = Date.parse(this.mySelf.getAttribute('min'));
                var max = Date.parse(this.mySelf.getAttribute('max'));
                var result = Date.parse(input.value);
                if (result > max || result < min) {
                    this.emitEventError(e);
                }
                else {
                    this.verifyNumRangeSelection(num);
                }
            }
            if (this.calendarBehavior && this.calendarBehavior.date) {
                this.calendarBehavior.updateDisplayedMonthsRage(this.calendarBehavior.date.getMonth(), this.calendarBehavior.date.getFullYear());
            }
        }
    };
    BcInputDateRangeBehavior.prototype.stylesInputReset = function () {
        if (this.inputDate.value) {
            this.inputDate.style.borderBottom = bc_date_constants_1.BcDateConstants.STYLE_BORDER_SOLID;
        }
        else {
            this.calendarBehavior.cleanStylesInputs(this.inputDate);
        }
        if (this.inputDateTwo.value) {
            this.inputDateTwo.style.borderBottom = bc_date_constants_1.BcDateConstants.STYLE_BORDER_SOLID;
        }
        else {
            this.calendarBehavior.cleanStylesInputs(this.inputDateTwo);
        }
    };
    BcInputDateRangeBehavior.prototype.verifyNumRangeSelection = function (num) {
        this.calendarBehavior.eventRangeRestore();
        var separator = this.inputDateBaehavior.validateSeparator(this.inputDate.value);
        var arrayDateSeparate = this.inputDate.value.split(separator);
        var date1 = new Date();
        date1.setMonth(Number(arrayDateSeparate[1]) - 1);
        date1.setDate(Number(arrayDateSeparate[bc_date_constants_1.BcDateConstants.NUMBERS.CALENDAR_N2]));
        date1.setFullYear(Number(arrayDateSeparate[0]));
        if (num == 1) {
            if (this.inputDateTwo.value) {
                var separatorInputTwo = this.inputDateBaehavior.validateSeparator(this.inputDateTwo.value);
                var arrayDateSeparateInputTwo = this.inputDateTwo.value.split(separatorInputTwo);
                var date2 = new Date(this.inputDateTwo.value);
                date2.setMonth(Number(arrayDateSeparateInputTwo[1]) - 1);
                date2.setDate(Number(arrayDateSeparateInputTwo[bc_date_constants_1.BcDateConstants.NUMBERS.CALENDAR_N2]));
                date2.setFullYear(Number(arrayDateSeparateInputTwo[0]));
                this.calendarBehavior.bcCalendarRange.automaticRangeDate(date1, date2, this.calendarBehavior);
            }
            else {
                var date2 = new Date(this.inputDateTwo.value);
                this.calendarBehavior.bcCalendarRange.automaticRangeDate(date1, date2, this.calendarBehavior);
            }
        }
        else {
            var date2 = new Date();
            var separator2 = this.inputDateBaehavior.validateSeparator(this.inputDateTwo.value);
            var arrayDateSeparate2 = this.inputDateTwo.value.split(separator2);
            date2.setMonth(Number(arrayDateSeparate2[1]) - 1);
            date2.setDate(Number(arrayDateSeparate2[bc_date_constants_1.BcDateConstants.NUMBERS.CALENDAR_N2]));
            date2.setFullYear(Number(arrayDateSeparate2[0]));
            this.calendarBehavior.bcCalendarRange.automaticRangeDate(date1, date2, this.calendarBehavior);
        }
    };
    BcInputDateRangeBehavior.prototype.change = function (value, origin) {
        this.calendarBehavior.eventRangeRestore();
        var date1;
        var date2;
        if (origin == 1) {
            date1 = this.inputDateBaehavior.buildDateToFormted(value, this.language).dateResult;
            date2 = new Date(this.inputDateTwo.value);
        }
        else {
            var resultDate = this.inputDateBaehavior.buildDateToFormted(this.inputDate.value, this.language);
            if (resultDate) {
                date1 = new Date(resultDate.dateResult);
                date2 = this.inputDateBaehavior.buildDateToFormted(value, this.language).dateResult;
            }
        }
        if (date2 == 'Invalid Date') {
            if (this.inputDateTwo.value) {
                date2 = this.inputDateBaehavior.buildDateToFormted(this.inputDateTwo.value, this.language).dateResult;
            }
        }
        this.calendarBehavior.bcCalendarRange.automaticRangeDate(date1, date2, this.calendarBehavior);
    };
    BcInputDateRangeBehavior.prototype.setValueInput = function (value, input) {
        if (value) {
            if (input) {
                if (this.inputDateTwo.type == 'date') {
                    this.inputDateTwo.value = value;
                }
                else {
                    this.validateDates(this.inputDateTwo, value);
                }
            }
            else {
                if (this.inputDate.type == 'date') {
                    this.inputDate.value = value;
                }
                else {
                    this.validateDates(this.inputDate, value);
                }
            }
        }
        else {
            this.inputDate.classList.remove(bc_date_constants_2.ACTIVE_CLASS_INPUT);
            this.inputDateTwo.classList.remove(bc_date_constants_2.ACTIVE_CLASS_INPUT);
            this.inputDate.value = '';
            this.inputDateTwo.value = '';
        }
    };
    BcInputDateRangeBehavior.prototype.validateScroll = function () {
        var dropdown = this.mySelf.getElementsByClassName(bc_abstract_dropdown_constants_1._DROPDOWN_CONTENT_ACTIVE_CLASS)[0];
        if (dropdown) {
            var content = dropdown.children[0];
            var validateWidth = (content.offsetHeight - dropdown.offsetHeight) > 0;
            if (validateWidth) {
                this.dropdownActive.style.maxHeight = null;
            }
        }
    };
    BcInputDateRangeBehavior.prototype.validateDates = function (input, target) {
        try {
            var _a = this.inputDateBaehavior.buildDateToFormted(target, this.language), dateResult = _a.dateResult, newDate = _a.newDate;
            var resultDate = this.calendarBehavior.dateToStringFormat(dateResult);
            if (dateResult) {
                var min = Date.parse(this.mySelf.getAttribute('min'));
                var max = Date.parse(this.mySelf.getAttribute('max'));
                var result = Date.parse(newDate);
                if (this.mySelf.getAttribute('min') && this.mySelf.getAttribute('max') && this.validateInputs) {
                    if (result <= max && result >= min) {
                        input.value = resultDate;
                        this.validateInputStatus(false, this.validateInputs, input);
                    }
                    else {
                        this.validateInputStatus(true, this.validateInputs, input);
                    }
                }
                else {
                    input.value = resultDate;
                    this.validateInputStatus(false, this.validateInputs, input);
                }
            }
            else {
                this.validateInputStatus(true, this.validateInputs, input);
            }
        }
        catch (error) {
            this.validateInputStatus(true, this.validateInputs, input);
        }
    };
    BcInputDateRangeBehavior.prototype.handleClick = function (e) {
        var _this = this;
        e.preventDefault();
        this.toggleDropdown();
        this.validateMobileDropdown();
        if (this.disabledScroll) {
            setTimeout(function () {
                _this.validateScroll();
            });
        }
    };
    BcInputDateRangeBehavior.prototype.validateInputStatus = function (statusUpdate, validate, input) {
        if (validate) {
            this.validatestatusInput(statusUpdate, input);
        }
        else {
            input.classList.add(bc_date_constants_2.ACTIVE_CLASS_INPUT);
        }
    };
    BcInputDateRangeBehavior.prototype.validatestatusInput = function (error, input) {
        if (error) {
            input.classList.add(bc_date_constants_2.ACTIVE_CLASS_INPUT);
            this.bcInputDateUtilities.errorInputUpdateClass(input, this.errorTextInput, this.calendarBehavior);
        }
        else {
            input.classList.add(bc_date_constants_2.ACTIVE_CLASS_INPUT);
            this.defaultInputUpdate(input, this.helpTextInput);
        }
    };
    BcInputDateRangeBehavior.prototype.setInputDateValues = function (e) {
        if (e.detail.clickDay) {
            console.log('dia1: ', e.detail.dateOne, 'dia2: ', e.detail.dateTwo);
            if (e.detail.dateOne) {
                this.inputDate.value = this.bcInputDateUtilities.getLocaleDatetoISOString(e.detail.dateOne, common_constants_1.COMMON_CONSTANTS_NUMBERS.N0, bc_date_constants_1.SIZE_DATE_STR);
            }
            else {
                this.inputDate.value = null;
            }
            if (e.detail.dateTwo) {
                this.inputDateTwo.value = this.bcInputDateUtilities.getLocaleDatetoISOString(e.detail.dateTwo, common_constants_1.COMMON_CONSTANTS_NUMBERS.N0, bc_date_constants_1.SIZE_DATE_STR);
            }
            else {
                this.inputDateTwo.value = null;
            }
        }
        else {
            this.inputDate.value = this.bcInputDateUtilities.getLocaleDatetoISOString(e.detail[common_constants_1.COMMON_CONSTANTS_NUMBERS.N0], common_constants_1.COMMON_CONSTANTS_NUMBERS.N0, bc_date_constants_1.SIZE_DATE_STR);
            this.inputDateTwo.value = this.bcInputDateUtilities.getLocaleDatetoISOString(e.detail[common_constants_1.COMMON_CONSTANTS_NUMBERS.N1], common_constants_1.COMMON_CONSTANTS_NUMBERS.N0, bc_date_constants_1.SIZE_DATE_STR);
            this.toggleDropdown();
        }
        this.emitEvent();
    };
    BcInputDateRangeBehavior.prototype.emitEvent = function () {
        var value = {
            initialDate: this.inputDate.value,
            toDate: this.inputDateTwo.value,
        };
        if (this.inputDate.value) {
            this.verifyInputDateOneType();
        }
        if (this.inputDateTwo.value) {
            this.verifyInputDateTwoType();
        }
        if (this.output) {
            this.output(value);
        }
    };
    BcInputDateRangeBehavior.prototype.emitEventError = function (event) {
        var error = {
            state: 'Error',
            event: event,
        };
        if (this.outputError) {
            this.outputError(error);
        }
    };
    BcInputDateRangeBehavior.prototype.verifyInputDateTwoType = function () {
        if (this.inputDateTwo.type == 'date') {
            this.inputDateTwoValue = this.inputDateTwo.value;
        }
        else {
            var input2Date = this.inputDateBaehavior.buildDateToFormted(this.inputDateTwo.value, this.language).dateResult;
            var resultInput2 = this.calendarBehavior.dateToStringFormat(input2Date);
            if (this.inputDateTwo.type == 'text') {
                this.setValuesNoEventDateTwo(resultInput2);
            }
            else if (this.inputDateTwo.type != 'text') {
                this.setValuesNoEventDateTwo(this.inputDateTwo.value);
            }
            else {
                this.setValuesNoEventDateTwo(this.inputDateTwo.value);
            }
        }
    };
    BcInputDateRangeBehavior.prototype.verifyInputDateOneType = function () {
        if (this.inputDate.type == 'date') {
            this.inputDateValue = this.inputDate.value;
        }
        else {
            var input1Date = this.inputDateBaehavior.buildDateToFormted(this.inputDate.value, this.language).dateResult;
            var resultInput1 = this.calendarBehavior.dateToStringFormat(input1Date);
            if (this.inputDate.type == 'text') {
                this.setValuesNoEventDateOne(resultInput1);
            }
            else if (this.inputDate.type != 'text') {
                this.setValuesNoEventDateOne(this.inputDate.value);
            }
            else {
                this.setValuesNoEventDateOne(this.inputDate.value);
            }
        }
    };
    BcInputDateRangeBehavior.prototype.setValues = function (value, valueTwo) {
        if (value && valueTwo) {
            this.inputDate.value = value;
            this.inputDateTwo.value = valueTwo;
            this.emitEvent();
        }
    };
    BcInputDateRangeBehavior.prototype.setValuesNoEventDateOne = function (value) {
        if (value) {
            this.inputDate.value = value;
            this.inputDate.classList.add(bc_date_constants_2.ACTIVE_CLASS_INPUT);
        }
    };
    BcInputDateRangeBehavior.prototype.setValuesNoEventDateTwo = function (valueTwo) {
        if (valueTwo) {
            this.inputDateTwo.value = valueTwo;
            this.inputDateTwo.classList.add(bc_date_constants_2.ACTIVE_CLASS_INPUT);
        }
    };
    BcInputDateRangeBehavior.prototype.setDisabled = function (isDisabled) {
        this.inputDate.disabled = isDisabled;
        this.inputDateTwo.disabled = isDisabled;
    };
    BcInputDateRangeBehavior.prototype.setupMinAndMaxDate = function () {
        var min = this.mySelf.getAttribute('min');
        var max = this.mySelf.getAttribute('max');
        if (min) {
            this.calendarElement.setAttribute('min', min);
        }
        if (max) {
            this.calendarElement.setAttribute('max', max);
        }
    };
    BcInputDateRangeBehavior.prototype._closeCalendarOutside = function () {
        var _a;
        var parentElement = (_a = this.mySelf) === null || _a === void 0 ? void 0 : _a.getElementsByClassName(bc_abstract_dropdown_constants_1._DROPDOWN_CONTENT_ACTIVE_CLASS)[0];
        var input = document.querySelector("".concat(bc_abstract_dropdown_constants_1._INPUT_DATE_RANGE, ".").concat(bc_abstract_dropdown_constants_1._DROPDOWN_ACTIVE_CLASS));
        if (parentElement && input) {
            this.closeDropdownOutsideElement([parentElement, input]);
        }
    };
    BcInputDateRangeBehavior.prototype.successInputUpdateClass = function () {
        var length = this.inputDate.parentElement.getElementsByTagName(common_constants_1.BcCommonConstants.EM_TAG).length;
        var icon = this.inputDate.parentElement.getElementsByTagName(common_constants_1.BcCommonConstants.EM_TAG)[length - 1];
        this.bcInputDateUtilities.successInputUpdateClass(this.inputDate, icon, this.successTextInput, this.calendarBehavior);
    };
    BcInputDateRangeBehavior.prototype.errorInputUpdateClass = function () {
        this.bcInputDateUtilities.errorInputUpdateClass(this.inputDate, this.errorTextInput, this.calendarBehavior);
    };
    BcInputDateRangeBehavior.prototype.successInputTwoUpdateClass = function () {
        var length = this.inputDateTwo.parentElement.getElementsByTagName(common_constants_1.BcCommonConstants.EM_TAG).length;
        var icon = this.inputDateTwo.parentElement.getElementsByTagName(common_constants_1.BcCommonConstants.EM_TAG)[length - 1];
        this.bcInputDateUtilities.successInputUpdateClass(this.inputDateTwo, icon, this.successTextInputTwo, this.calendarBehavior);
    };
    BcInputDateRangeBehavior.prototype.errorInputTwoUpdateClass = function () {
        this.bcInputDateUtilities.errorInputUpdateClass(this.inputDateTwo, this.errorTextInputTwo, this.calendarBehavior);
    };
    BcInputDateRangeBehavior.prototype.setDefaultStatusInputClass = function () {
        this.defaultInputUpdate(this.inputDate, this.helpTextInput);
    };
    BcInputDateRangeBehavior.prototype.setDefaultStatusInputTwoClass = function () {
        this.defaultInputUpdate(this.inputDateTwo, this.helpTextInputTwo);
    };
    BcInputDateRangeBehavior.prototype.defaultInputUpdate = function (input, helpText) {
        this.bcInputDateUtilities.removeClassInput(input);
        this.stylesInputReset();
        if (input.parentElement.querySelector(common_constants_1.BcCommonConstants.SPAN_TAG)) {
            var span = input.parentElement.querySelector(common_constants_1.BcCommonConstants.SPAN_TAG);
            span.innerHTML = helpText;
        }
        var length = input.parentElement.getElementsByTagName(common_constants_1.BcCommonConstants.EM_TAG).length;
        var icon = input.parentElement.getElementsByTagName(common_constants_1.BcCommonConstants.EM_TAG)[length - 1];
        icon.innerHTML = this.originalIcon;
    };
    BcInputDateRangeBehavior.prototype.validateMobileDropdown = function () {
        var dropdownActive = this.mySelf.getElementsByClassName(bc_date_constants_7.DROPDOWN_CONTENT_ACTIVE)[common_constants_1.COMMON_CONSTANTS_NUMBERS.N0];
        if (this.bcInputDateUtilities.maxScreenWidth() && dropdownActive) {
            dropdownActive.style.zIndex = "".concat(bc_date_constants_8.Z_INDEX_DROPDOWN_MOBILE);
        }
    };
    return BcInputDateRangeBehavior;
}(bc_abstract_dropdown_behavior_1.BcAbstractDropdownBehavior));
exports.BcInputDateRangeBehavior = BcInputDateRangeBehavior;
